import React, { useEffect, useMemo, useState } from 'react';
import Layout from "@shared/ui/organisms/layout/Layout";
import { FadeAndPop } from '@shared/animations/AnimationVariants';
import { HeadlineLarge } from "@shared/ui/atoms/fonts/Headline";
import { BodyError, BodyRegular } from "@shared/ui/atoms/fonts/Body";
import styled from "styled-components";
import { LinkButton } from "@shared/ui/atoms/buttons/LinkButton";
import { useLocation } from "react-router";
import { getParameterByName } from '@shared/utils/UrlUtils';
import { unsubscribeRequest } from '@features/settings/services/UserService';
import { LoadingSpinner } from "@shared/ui/atoms/LoadingSpinner";
import { Trans, useTranslation } from "react-i18next";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';


enum State {
  loading, successful, failed,
}

export default function UnsubscribePage() {
  const [state, setState] = useState(State.loading);
  const location = useLocation();
  const id = useMemo(() => getParameterByName('id', location.search), [location]);

  useEffect(() => {
    setState(State.loading)
    if (id) {
      unsubscribeRequest(id)
        .then(() => setState(State.successful))
        .catch(() => setState(State.failed))

    }
  }, [id]);

  return (
    <Layout>
      {state === State.loading && <LoadingSpinner fullScreen={true}/>}
      <FadeAndPop hidden={false}>
        <UnsubscribeWrapper>
          {state === State.successful && <Success/>}
          {state === State.failed && <Failed/>}
        </UnsubscribeWrapper>
      </FadeAndPop>
    </Layout>
  );
}

const Success = () => {
  const {t} = useTranslation();
  return (<>
    <HeadlineLarge style={{marginBottom: 24}}>{t('unsubscribe-page.unsubscribed-title')}</HeadlineLarge>
    <BodyRegular style={{marginBottom: 16}}>{t('unsubscribe-page.unsubscribed-message-1')}</BodyRegular>
    <BodyRegular style={{marginBottom: 48}}>{t('unsubscribe-page.unsubscribed-message-2')}</BodyRegular>
    <LinkButton text="button.log-in" link="/login" fullWidth={true} size={ButtonSize.Large}/>
  </>)

};

const Failed = () => {
  const {t} = useTranslation();
  return (<>
      <HeadlineLarge style={{marginBottom: 24}}>{t('unsubscribe-page.unsubscribed-failed-title')}</HeadlineLarge>
      <BodyError style={{marginBottom: 16}}>{t('unsubscribe-page.unsubscribed-failed-message')}</BodyError>
      <BodyRegular style={{marginBottom: 48}}>
        <Trans i18nKey={'unsubscribe-page.unsubscribed-contact'} components={[<a href={'mailto:hello@team-today.com'}>hello@team-today.com</a>]} />
      </BodyRegular>
      <LinkButton text="button.log-in" link="/login" fullWidth={true} size={ButtonSize.Large}/>
    </>)
};


const UnsubscribeWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
`
